import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test": "details-empty",
  class: "details__empty"
}
const _hoisted_2 = {
  key: 1,
  class: "details"
}
const _hoisted_3 = { class: "detail__key" }
const _hoisted_4 = { class: "detail__value" }
const _hoisted_5 = ["onUpdate:modelValue", "aria-label", "onKeydown", "onBlur"]
const _hoisted_6 = {
  key: 1,
  class: "detail__text"
}
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = { "data-test": "details-count" }

import { computed, nextTick, onMounted, ref } from 'vue'

import ConfirmModal from '@/components/ConfirmModal.vue'
import { isNotesAttribute } from '@/components/customers/profile/notesKey'
import RecordButton from '@/components/customers/record/RecordButton.vue'
import RecordTableCard from '@/components/customers/record/RecordTableCard.vue'
import { useToast } from '@/composables/useToast'
import api from '@/store/api'

const PAGE_SIZE = 6


export default {
  __name: 'ProfileAttrs',
  props: {
  conversationUserPairId: { type: String, required: true },
  editable: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const { showToast } = useToast()

const attrs = ref([])
const expanded = ref(false)
const adding = ref(false)
const newKey = ref('')
const newValue = ref('')
const keyField = ref(null)

const endpoint = () => `conversation_user_pairs/${props.conversationUserPairId}/custom_attributes`

const toDetail = attr => {
  const value = attr.attributes.value_string ?? ''
  return { id: attr.attributes.id, key: attr.attributes.key_string_downcased, value, saved: value }
}

const displayKey = key => {
  const text = String(key ?? '').replace(/_/g, ' ')
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const visibleAttrs = computed(() => (expanded.value ? attrs.value : attrs.value.slice(0, PAGE_SIZE)))

const revert = (attr, event) => {
  attr.value = attr.saved
  event.target.blur()
}

const saveAttr = attr => {
  if (attr.value === attr.saved) return
  if (!attr.value.trim()) {
    attr.value = attr.saved
    return
  }
  api
    .call('PUT', `${endpoint()}/${attr.id}`, { custom_attribute: { key_string: attr.key, value_string: attr.value } })
    .then(response => {
      attr.saved = response.data.data.attributes.value_string
    })
    .catch(() => {
      attr.value = attr.saved
      showToast("Couldn't save that detail. Please try again.", { type: 'error' })
    })
}

const removing = ref(null)
const removeTitle = computed(() => (removing.value ? `Remove ${displayKey(removing.value.key)}?` : ''))

const removeAttr = () => {
  const attr = removing.value
  removing.value = null
  if (!attr) return
  api
    .call('DELETE', `${endpoint()}/${attr.id}`, {}, { receive: false })
    .then(() => {
      attrs.value = attrs.value.filter(item => item.id !== attr.id)
    })
    .catch(() => showToast("Couldn't remove that detail. Please try again.", { type: 'error' }))
}

const startAdding = async () => {
  adding.value = true
  await nextTick()
  keyField.value?.focus()
}

const cancelAdding = () => {
  adding.value = false
  newKey.value = ''
  newValue.value = ''
}

const addAttr = () => {
  if (!newKey.value || !newValue.value) return
  api
    .call('POST', endpoint(), { custom_attribute: { key_string: newKey.value, value_string: newValue.value } })
    .then(response => {
      attrs.value.push(toDetail(response.data.data))
      if (attrs.value.length > PAGE_SIZE) expanded.value = true
      cancelAdding()
    })
    .catch(error => {
      showToast(
        error.response?.status === 422
          ? 'A detail with that name already exists.'
          : "Couldn't add that detail. Please try again.",
        { type: 'error' }
      )
    })
}

onMounted(() => {
  api.call('GET', endpoint()).then(response => {
    attrs.value = response.data.data.filter(attr => !isNotesAttribute(attr)).map(toDetail)
  })
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(RecordTableCard, {
    "data-test": "attributes-card",
    title: "Saved details"
  }, _createSlots({
    default: _withCtx(() => [
      (attrs.value.length === 0 && !adding.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "No saved details yet."))
        : (attrs.value.length > 0)
          ? (_openBlock(), _createElementBlock("dl", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleAttrs.value, (attr) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: attr.id,
                  "data-test": "detail",
                  class: "detail"
                }, [
                  _createElementVNode("dt", _hoisted_3, _toDisplayString(displayKey(attr.key)), 1),
                  _createElementVNode("dd", _hoisted_4, [
                    (__props.editable)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": $event => ((attr.value) = $event),
                          type: "text",
                          class: "detail__input",
                          "aria-label": displayKey(attr.key),
                          onKeydown: [
                            _cache[0] || (_cache[0] = _withKeys(event => event.target.blur(), ["enter"])),
                            _withKeys(event => revert(attr, event), ["esc"])
                          ],
                          onBlur: $event => (saveAttr(attr))
                        }, null, 40, _hoisted_5)), [
                          [_vModelText, attr.value]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(attr.value), 1)),
                    (__props.editable)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          "data-test": "remove-detail",
                          class: "detail__remove",
                          "aria-label": `Remove ${displayKey(attr.key)}`,
                          onClick: $event => (removing.value = attr)
                        }, " × ", 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
      (adding.value)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            "data-test": "detail-form",
            class: "detail-form",
            onSubmit: _withModifiers(addAttr, ["prevent"])
          }, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "keyField",
              ref: keyField,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((newKey).value = $event)),
              type: "text",
              class: "detail-form__input",
              placeholder: "Detail",
              "aria-label": "Detail name"
            }, null, 512), [
              [
                _vModelText,
                newKey.value,
                void 0,
                { trim: true }
              ]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((newValue).value = $event)),
              type: "text",
              class: "detail-form__input",
              placeholder: "Value",
              "aria-label": "Detail value"
            }, null, 512), [
              [
                _vModelText,
                newValue.value,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode(RecordButton, {
              type: "submit",
              variant: "primary",
              size: "sm"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Add", -1)
              ]))]),
              _: 1
            }),
            _createVNode(RecordButton, {
              variant: "quiet",
              size: "sm",
              onClick: cancelAdding
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            })
          ], 32))
        : _createCommentVNode("", true),
      _createVNode(ConfirmModal, {
        "is-open": Boolean(removing.value),
        title: removeTitle.value,
        message: "It comes off this customer's saved details.",
        "confirm-label": "Remove",
        "cancel-label": "Keep",
        onConfirm: removeAttr,
        onClose: _cache[3] || (_cache[3] = $event => (removing.value = null))
      }, null, 8, ["is-open", "title"])
    ]),
    _: 2
  }, [
    (__props.editable || attrs.value.length > PAGE_SIZE)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            (__props.editable && !adding.value)
              ? (_openBlock(), _createBlock(RecordButton, {
                  key: 0,
                  "data-test": "add-detail",
                  size: "sm",
                  onClick: startAdding
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" Add a detail ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (attrs.value.length > PAGE_SIZE)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", _hoisted_8, "Showing " + _toDisplayString(visibleAttrs.value.length) + " of " + _toDisplayString(attrs.value.length), 1),
                  _createVNode(RecordButton, {
                    "data-test": "details-toggle",
                    class: "ml-auto",
                    size: "sm",
                    onClick: _cache[4] || (_cache[4] = $event => (expanded.value = !expanded.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(expanded.value ? 'Show fewer' : 'Show all'), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

}